export enum ShopRoutingEnum {
    CALENDAR = 'calendar',
    HISTORY = 'history',
    SETTINGS = 'settings',
}
